var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("hr", {
      staticStyle: {
        "flex-basis": "100%",
        height: "0",
        margin: "0",
        border: "0",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "w-100 p-3" }, [
      _c("div", {
        staticClass: "automation-email-content-preview",
        domProps: { innerHTML: _vm._s(_vm.textHTML) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }